<div class="row w100 space-between align-end">
  <span class="inputlabel" *ngIf="label !== ''"
    >{{ label }}<span *ngIf="required" class="color-weak"> *</span></span
  >
  <rr-btn
    *ngIf="btnType"
    [iconStart]="btnIconStart"
    [iconEnd]="btnIconEnd"
    [disabled]="btnDisabeld"
    [type]="btnType"
    size="small"
    (click)="onBtnClick()"
    >{{ btnText }}</rr-btn
  >
</div>
<div
  *ngIf="FormControl.invalid && (FormControl.dirty || FormControl.touched)"
  class="input-error"
>
  <rr-icon name="octagon"></rr-icon>
  <span *ngIf="FormControl.hasError('required')" i18n
    >This field is required</span
  >
</div>
<div
  class="texareawrapper"
  [ngClass]="
    FormControl.invalid && (FormControl.dirty || FormControl.touched)
      ? 'error'
      : ''
  "
>
  <textarea
    [formControl]="FormControl"
    [placeholder]="placeholder"
    [attr.disabled]="disabled ? true : null"
    (keyup)="chekValue()"
  ></textarea>
</div>
